/* eslint-disable react/no-array-index-key */
import React, { Fragment, useState, useEffect, useRef } from 'react'
import { Input, Image, Button } from 'antd'
import crossIcon from '@/assets/svg/cross-request.svg'
import checkIcon from '@/assets/svg/tasks/tick.svg'
// import { ArrowIcon } from '@/components/IconsCustom'
import { Popup } from '@/components/Popups'
import SpecifyQuantity from '@/components/Popups/SpecifyQuantity'

export interface SelectFieldPopUpProps {
  isRequired?: boolean
  requestError?: boolean
  editMode?: boolean
  label?: string
  validate?: any
  validMessage?: string
  className?: string
  dropRole?: string
  setDropRole?: any
  initValue?: any
  rules?: any
  iProps?: any
  selectOption?: any
  reqItemArray?: any
  setReqItemArray?: any
  setDeleteRequest?: any
  data?: any
  searchItems: (e: any) => void
  setDepartRoleName: React.Dispatch<
    React.SetStateAction<{
      role: string
      departmentName: string
    }>
  >
}

const SelectFieldPopUp: React.FunctionComponent<SelectFieldPopUpProps> = ({
  isRequired,
  label,
  validate,
  validMessage,
  className,
  initValue,
  selectOption,
  reqItemArray,
  setReqItemArray,
  requestError,
  setDeleteRequest,
  data,
  dropRole,
  setDropRole,
  editMode,
  searchItems,
  setDepartRoleName,
}: SelectFieldPopUpProps) => {
  const [dropValue, setDropValue] = useState<string>('')

  const [dropLabel, setDropLabel] = useState<string>('')
  const [reqSelectedData, setReqSelectedData] = useState<any>({})
  const [openDropdown, setOpenDropdown] = useState<boolean>(false)
  const [optionQty, setOptionQty] = useState<number>(0)
  const [qtyValue, setQtyValue] = useState<number | null>(null)
  const [specify, setSpecify] = useState<boolean>(false)
  const [qtyError, setQtyError] = useState<boolean>(false)
  const [optionArray, setOptionArray] = useState<Array<any>>([])
  const [selectOptions, setSelectOptions] = useState({})
  const [textField, setTextField] = useState('')
  const ref = useRef<any>(null)

  // const [array, setArray] = useState([1, 2, 3, 4, 5])
  // const [inputValues, setInputValues] = useState<string>('')

  // const optionSelect = (e: any) => {
  //   if (e) {
  //     const array = []
  //     array.push(e)
  //     setOptionQty([...optionQty, array])
  //     setOpen(false)
  //     // setConfirmDelete(true)
  //   } else {
  //     setConfirmDelete(false)
  //   }
  // }

  useEffect(() => {
    setSelectOptions(selectOption)
  }, [selectOption])

  useEffect(() => {
    if (!editMode) {
      ref.current.focus()
      setOpenDropdown(true)
    }
  }, [editMode])

  useEffect(() => {
    if (data && data?.requestsBody?.length > 0) {
      const specifyReq: any[] = []
      const reqPayload: any[] = []
      data?.requestsBody?.map((e: any) => {
        console.log('e---', e)
        reqPayload.push({
          id: e?.id,
          item_name: e?.label,
          item_id: e?.value,
          qty: e?.qty,
          role: e.role,
        })
        specifyReq.push({
          id: e?.id,
          value: e?.value,
          label: e?.isCountable ? `${e?.label} - Qty: ${e?.qty}` : e?.label,
        })
        setDropRole(e?.roleDisplayName)
        setDepartRoleName({ departmentName: e?.departmentName, role: e?.role })
        return specifyReq
      })
      setOptionArray(specifyReq)
      setReqItemArray(reqPayload)
    } else {
      setOptionArray([])
      setDepartRoleName({ departmentName: '', role: '' })
      setDropRole('')
    }
  }, [data, setReqItemArray, setDropRole, setDepartRoleName])

  const onSearchChange = (e: any) => {
    if (e.target.value) {
      if (!editMode) {
        ref.current.focus()
        setOpenDropdown(true)
      }

      searchItems(e.target.value)
      setTextField(e.target.value)
    } else {
      setTextField('')
      searchItems('')
    }
  }

  const getLabel = (e: any) => {
    setDropLabel(e.label)
    setDropValue(e.value)
    setDropRole(e.roleDisplayName)
    setTextField('')
    setReqSelectedData(e)
    setOpenDropdown(false)
    setDepartRoleName({ departmentName: e?.departmentName, role: e?.role })
    if (e?.isCountable) {
      setSpecify(true)
    } else {
      setSpecify(false)
      const tempArray = {
        id: e.id,
        value: e?.value,
        label: e.label,
        backOfficeDue: e?.backOfficeDueTime,
        guestDueTime: e?.guestDueTime,
      }
      const reqPayload = {
        item_id: e.value,
        role: e.role,
        backOfficeDue: e?.backOfficeDueTime,
        guestDueTime: e?.guestDueTime,
      }
      setOptionArray([...optionArray, tempArray])
      setReqItemArray([...reqItemArray, reqPayload])
    }
  }

  const handleChange = (value: number) => {
    setOptionQty(value)
    setQtyValue(value)
  }

  const valueSelected = () => {
    if (optionQty === 0) {
      setQtyError(true)
      return
    }

    if (optionQty) {
      setQtyError(false)
      const finalValue = `${dropLabel} - Qty: ${optionQty}`
      const array = []
      const reqPayload = {
        id: undefined,
        item_id: dropValue,
        qty: optionQty,
        role: dropRole,
        backOfficeDue: reqSelectedData?.backOfficeDueTime,
        guestDueTime: reqSelectedData?.guestDueTime,
      }
      setReqItemArray([...reqItemArray, reqPayload])
      array.push({
        id: dropValue,
        value: dropValue,
        label: finalValue,
      })
      setOptionArray([...optionArray, ...array])
      setSpecify(false)
      setOptionQty(0)
      setDropValue('')
      setDropLabel('')
      setOpenDropdown(false)
      setTextField('')
      setQtyValue(null)
    }
  }
  let deleteReqnew: any = []
  const [delArray, setdelArray] = useState<any>([])

  const deleteItems = (x: any, i: number) => {
    if (optionArray && optionArray?.length === 1) {
      setDropRole('')
      setDepartRoleName({ departmentName: '', role: '' })
      setSelectOptions(selectOption)
    }

    const index = optionArray.indexOf(x)
    if (index > -1) {
      optionArray.splice(index, 1)
      const newValue = Object.assign([], optionArray)
      setOptionArray(newValue)

      if (reqItemArray) {
        reqItemArray?.splice(index, 1)
        const newReqItem = Object.assign([], reqItemArray)
        setReqItemArray(newReqItem)
      }

      data?.requestsBody?.map((e: any) => {
        if (e?.id === x?.id) {
          setdelArray([...delArray, e?.id])
          deleteReqnew = [...delArray, e?.id]
        }
        return deleteReqnew
      })

      if (deleteReqnew && deleteReqnew?.length > 0) {
        setDeleteRequest(deleteReqnew)
      }
    }
  }

  const toggleOpen = () => {
    ref.current.focus()
    setOpenDropdown(!openDropdown)
  }

  return (
    <>
      <div
        className={
          requestError && optionArray?.length === 0 ? 'error_request request_body' : 'request_body'
        }
      >
        <div className={openDropdown ? 'task_top_select active_dropdown' : 'task_top_select'}>
          <div className="chips_wrapper">
            {optionArray && (
              <div className="top_chips">
                {optionArray?.map((x: any, i: number) => (
                  <div className="selected_options" key={i}>
                    <span>{x?.label}</span>
                    <Button className="close_btn" onClick={() => deleteItems(x, i)}>
                      <Image src={crossIcon} preview={false} width={18} />
                    </Button>
                  </div>
                ))}
              </div>
            )}
            <Input
              size="large"
              placeholder=" "
              value={textField}
              onChange={onSearchChange}
              ref={ref}
              className={optionArray?.length > 0 ? 'input_padding' : ''}
            />
          </div>

          <div className="chips_btn">
            <div
              className="custom_task_select"
              onClick={toggleOpen}
              role="button"
              tabIndex={0}
              onKeyDown={toggleOpen}
              onBlur={() => {
                setTimeout(() => {
                  toggleOpen()
                }, 500)
              }}
            >
              {(optionArray && optionArray?.length > 0) || textField ? ' ' : 'Specify Request'}
            </div>
          </div>
          {requestError && optionArray?.length === 0 && (
            <div className="request_error_text">Request is required.</div>
          )}
        </div>

        {openDropdown && (
          <div id="scroll" className="dropdown_request">
            {selectOptions && Object.keys(selectOptions)?.length > 0 ? (
              Object.entries(selectOptions)?.map(([k, v]: any) => (
                <Fragment key={k}>
                  <div className="dropdown_group">
                    <div
                      className={
                        k.toLowerCase() === 'popular' ? 'group_name popular_group' : 'group_name'
                      }
                    >
                      {k}
                    </div>

                    <ul>
                      {v &&
                        v?.map((e: any, i: number) => (
                          <li
                            key={i}
                            className={
                              optionArray?.some((res) => res.value === e.value) ? 'active_list' : ''
                            }
                          >
                            <div
                              onClick={() =>
                                optionArray?.some((res) => res.value === e.value) ? {} : getLabel(e)
                              }
                              role="button"
                              tabIndex={0}
                              onKeyDown={() => getLabel(e)}
                              className="dropdown_list"
                            >
                              {e?.label}
                              {optionArray?.some((res) => res.value === e.value) && (
                                <img src={checkIcon} alt="check" />
                              )}
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </Fragment>
              ))
            ) : (
              <div className="no_result">
                No results found. Request should be created in task settings. Please contact your
                administrator.
              </div>
            )}
          </div>
        )}
      </div>

      <Popup
        closable={false}
        visibility={specify}
        className="white-modal"
        content={
          <SpecifyQuantity
            title="Specify Quantity"
            onClose={() => `${setSpecify(false)}  ${setQtyError(false)}`}
            setOptionQty={() => setOptionQty(0)}
            handleChange={handleChange}
            value={qtyValue}
            qtyError={qtyError}
            valueSelected={() => {
              valueSelected()
            }}
          />
        }
        width={400}
      />
    </>
  )
}

export default SelectFieldPopUp
